import { createDerivedWritableAtom } from '../../../utils';
import { visitorAtom } from '../../state';

export const admissionAttemptsAtom = createDerivedWritableAtom(visitorAtom, 'admissionAttempts');

export const joinAttemptsAtom = createDerivedWritableAtom(visitorAtom, 'joinAttempts');

export const isProviderNotHereModalOpenAtom = createDerivedWritableAtom(visitorAtom, 'isProviderNotHereModalOpen');
